import calendar from '@r1-frontend/ui-react/assets/img/icons/calendar.svg';
import question from '@r1-frontend/ui-react/assets/img/icons/question.svg';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled, { css } from 'styled-components';

const commonStyles = css`
    &:disabled {
        border-color: ${COLORS.BgSecondary};
        background-color: ${COLORS.BgSecondary};
        color: ${COLORS.TextDisabled};
    }

    &::placeholder {
        color: ${COLORS.TextDisabled};
    }
`;

export const InputContainer = styled.div`
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    flex-direction: column;
`;

export const Eye = styled.img`
    position: absolute;
    object-fit: none;
    top: 0;
    right: 10px;
    width: 48px;
    height: 48px;
    cursor: pointer;

    &:hover {
        filter: invert(1);
    }
`;

export const StyledInput = styled.input`
    height: 48px;
    width: 100%;
    padding: 14px 0 14px 16px;
    padding-right: ${props => props.isIconExist ? '50px' : '0'};
    ${FONTS.XS};
    color: ${COLORS.TextPrimary};
    border: 2px solid ${p => p.notValid ? COLORS.Error : COLORS.BgSecondary};
    border-radius: ${BorderRadius.componentRadius};
    opacity: ${props => props.pretty ? '0' : '1'};
    transition: border 0.2s ease-in;
    outline: none;
    box-shadow: none;
    box-sizing: border-box;
    ${commonStyles};

    &:not(:placeholder-shown) {
        border-color: ${p => p.notValid ? COLORS.Error : COLORS.GRAY_LIGHT};
    }

    &:focus, &:hover {
        border-color: ${p => p.notValid ? COLORS.Error : COLORS.GRAY_DARK};

        & ~ ${Eye} {
            filter: invert(1);
        }
    }

    &::-ms-clear,
    &::-ms-reveal,
    &:focus::-ms-clear, ::-ms-reveal {
        display: none !important;
    }
    &[type=number]::-webkit-inner-spin-button,
    &[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    -webkit-text-security: ${props => props.showText ? 'none' : 'disc'}!important;
`;

export const PrettyText = styled.div`
    height: 48px;
    padding: 14px 0 14px 16px;
    ${FONTS.XS};
    color: ${COLORS.TextPrimary};
    border: 2px solid ${COLORS.BgSecondary};
    border-radius: ${BorderRadius.componentRadius};
    transition: border 0.2s ease-in;
    outline: none;
    box-shadow: none;
    background: ${COLORS.BgMain};
    align-items: center;
    width: inherit;
    position: absolute;
    box-sizing: border-box;
    top: 0;

    ${p => p.isDisabled
        ? css`
            border-color: ${COLORS.BgSecondary};
            background-color: ${COLORS.BgSecondary};
            color: ${COLORS.TextDisabled};
        `
        : css`
            &:focus, &:hover {
                border-color: ${COLORS.GRAY_DARK};
            }
        `
    }

    &:not(:placeholder-shown) {
        border-color: ${COLORS.GRAY_LIGHT};
    }
`;

export const InputError = styled.p`
    display: block;
    ${FONTS.XXS};
    margin: 0;
    color: ${COLORS.Error};
    transition: opacity 0.2s ease-in-out;
`;

export const CalendarIcon = styled.div`
    position: absolute;
    background-image: url(${calendar});
    background-repeat: no-repeat;
    background-position: 50%;
    top: 0;
    right: 10px;
    width: 48px;
    height: 48px;
    cursor: pointer;
`;

export const QuestionIcon = styled.div`
    position: absolute;
    background-image: url(${question});
    background-repeat: no-repeat;
    background-position: 50%;
    top: 0;
    right: 10px;
    width: 48px;
    height: 48px;
    cursor: pointer;
`;

export const DescriptionBlock = styled.div`
    ${FONTS.XXS};
    margin: 0;
    color: ${COLORS.TextDisabled};
`;
